import SectionHeading from '@/components/base/SectionHeading';
import { steps } from '@/mocks/home';

export default function StepsSection() {
  return (
    <section id="steps" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="四步攻略"
          title="17.cc 吃瓜教程：四步跑通一次完整流程"
          desc="这是整份攻略的核心。无论追什么类型的热点，都可以按这四步走：先定位、再筛选、然后梳理、最后跟进。"
        />

        <div className="relative mt-12 md:mt-16">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-background-300 lg:block"></div>
          <ol className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
            {steps.map((step) => (
              <li key={step.num} className="relative">
                <div className="flex items-center gap-3 lg:flex-col lg:items-start">
                  <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-4 border-background-100 bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {step.num}
                  </span>
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 font-label text-xs font-medium text-accent-800">
                    <i className="ri-price-tag-3-line text-xs" aria-hidden="true"></i>
                    {step.tag}
                  </span>
                </div>

                <div className="mt-4 rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300/70">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {step.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <p className="mt-8 flex items-start gap-2.5 rounded-lg border border-background-300/70 bg-background-50 p-4 text-sm leading-relaxed text-foreground-600 md:items-center">
          <i className="ri-lightbulb-line mt-0.5 shrink-0 text-lg text-accent-600 md:mt-0" aria-hidden="true"></i>
          <span>
            小提示：第一遍不必追求「吃透」，先按四步把一件事完整走完。
            <strong className="font-medium text-foreground-900">流程熟悉之后</strong>
            ，再回头补细节会顺畅得多。这一步也是所有吃瓜技巧的基础。
          </span>
        </p>
      </div>
    </section>
  );
}